import { httpPost } from "@/request/http";
import func from "@/funcs";

export default function (url, formData, timeout) {
  let headers = { "Content-Type": "multipart/form-data" };
  if (timeout != undefined) headers.timeout = timeout;
  return new Promise((resolve, reject) => {
    httpPost(url, formData, headers)
      .then((data) => {
        func.message({
          type: "success",
          mainMessage: "匯入成功 !",
        });
        resolve(data);
      })
      .catch((response) => {
        func.message({
          type: "error",
          mainMessage: "匯入失敗 !",
        });
        reject(response);
      });
  });
}
